<atlas-modal>
  <atlas-modal-header>
    {{ 'SWITCH_LANGUAGE_MODAL.SWITCH_LANGUAGE' | translate }}
  </atlas-modal-header>
  <atlas-modal-content>
    @if (impersonating$ | async) {
      <div class="atlas-navbar__language-selector-modal__impersonation-warning">
        <glxy-alert [type]="'warning'" [size]="'small'">
          {{ 'SWITCH_LANGUAGE_MODAL.IMPERSONATION_WARNING' | translate }}
        </glxy-alert>
      </div>
    }
    <div class="atlas-navbar__language-selector-modal__container">
      <div class="atlas-navbar__language-selector-modal__list">
        <atlas-language-list
          [languages]="languages$ | async"
          (languageSelected)="languageSelected($event)"
        ></atlas-language-list>
      </div>
    </div>
  </atlas-modal-content>
  @if (translatePortalUrl$ | async; as translatePortalUrl) {
    <atlas-modal-footer
      class="atlas-navbar__language-selector-modal__translation-prompt"
      >
      <span class="atlas-navbar__language-selector-modal__translation-prompt__label">
        {{ 'SWITCH_LANGUAGE_MODAL.HELP_US_TRANSLATE' | translate }}
      </span>
      @if (!urlIsExternal(translatePortalUrl)) {
        <a
          class="atlas-navbar__language-selector-modal__translation-prompt__link"
          [routerLink]="translatePortalUrl"
          >
          {{ 'SWITCH_LANGUAGE_MODAL.VISIT_TRANSLATION_PORTAL' | translate }}
        </a>
      }
      @if (urlIsExternal(translatePortalUrl)) {
        <a
          class="atlas-navbar__language-selector-modal__translation-prompt__link"
          target="_blank"
          [href]="translatePortalUrl"
          >
          {{ 'SWITCH_LANGUAGE_MODAL.VISIT_TRANSLATION_PORTAL' | translate }}
          <i class="atlas-navbar__language-selector-modal__translation-prompt__icon material-icons">open_in_new</i>
        </a>
      }
    </atlas-modal-footer>
  }
</atlas-modal>
